import React from "react";
import { Table } from "react-bootstrap";
import LoadingSpinner from "views/Components/loadingSpinner";

const ProductListTable = ({ products, isNotFound, isLoading }) => {
  return (
    <>
      <Table responsive>
        <thead>
          <tr>
            <th>TITLE</th>
            <th>SUPPLIER NAME</th>
            <th>SUPPLIER MOBILE</th>
            <th>BUYING PRICE</th>
            <th>FREE ITEM</th>
            <th>PACK SIZE</th>
            <th>CREATED AT</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan="10">
                <LoadingSpinner />
              </td>
            </tr>
          ) : isNotFound ? (
            <tr>
              <td colspan="10">
                <center>No record found</center>
              </td>
            </tr>
          ) : (
            <React.Fragment>
              {products.map((cus) => (
                <tr key={cus.id}>
                  <td>{cus.title}</td>
                  <td>{cus.suppliers_data.name}</td>
                  <td>{cus.suppliers_data.mobile}</td>
                  <td>{cus.unit_price}</td>
                  <td>{cus.bonus_qty}</td>
                  <td>{cus.pack_size}</td>
                  <td>{cus.created_at}</td>
                </tr>
              ))}
            </React.Fragment>
          )}
        </tbody>
      </Table>
    </>
  );
};

export default ProductListTable;
